import React, { Component } from "react";
import {
  Box,
  Card,
  Container,
  Divider,
  Grid,
  TextField,
  MenuItem,
  Button,
  Skeleton,
  Avatar,
  Link,
  Modal,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import Autocomplete from "react-google-autocomplete";
import Menu from "@mui/material/Menu";
import Paper from "@mui/material/Paper";
import poo from "./assets/bgimg.jpg";
import MicIcon from "@mui/icons-material/Mic";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import rr from "./img/penter.png";
import ccc from "./img/new_home.jpg";
import d from "./img/d.webp";
import l from "./img/l.webp";
import HomeIcon from "@mui/icons-material/Home";
import property from "./img/property.webp";
import SearchIcon from "@mui/icons-material/Search";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

import CheckIcon from "@mui/icons-material/Check";
import socity_img from './socity_img/socity.jpg'
import CallIcon from '@mui/icons-material/Call';
import EastIcon from '@mui/icons-material/East';




///// vendor
import car from './vendor_assets/car.png'
import manufacturer from './vendor_assets/manufacturer.png'
import penter from './vendor_assets/penter.png'

import base from '../src/base.json'
import consultant_agency  from '../src/vendor_assets/consultant_agency.png'
import VoiceToText from "./VoiceToText";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import animation from '../src/animation.gif'





import one from '../src/buildingimg/one.webp'
import two from '../src/buildingimg/two.webp'
import three from '../src/buildingimg/three.webp'
import four from '../src/buildingimg/four.jpg'


import five from '../src/buildingimg/five.jpg'
import six from '../src/buildingimg/six.jpg'
import seven from '../src/buildingimg/seven.jpg'
import eight from '../src/buildingimg/eight.jpg'
import nine from '../src/buildingimg/nine.jpg'
import ten from '../src/buildingimg/ten.jpg'
import eleven from '../src/buildingimg/eleven.jpeg'
import twelve from '../src/buildingimg/twelve.png'

import AppHeader from '../src/AppHeader'
import Footer from '../src/Footer'
import CloseIcon from   "@mui/icons-material/Close"

///AIzaSyDg2LA8IAl3SPgxqiAt1FBNb54Z8jk4kZ0
const api_key = "AIzaSyDg2LA8IAl3SPgxqiAt1FBNb54Z8jk4kZ0";
export class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "buy",
      anchorEl: null,
      open: false,
      display: false,

      //////////////// state data for location search field
      location_name: "",

       is_enquiry_open :false,
      ////////////////// desktop viewable data 
       
   
   flats : [],
   commercial : [],
   land : [],
   independent_house:[],

/////////////////////////////////////
name :"",
email:"",
phone:"",
propertyDetails :{},



    };
    this.setAnchorEl = this.setAnchorEl.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.child = React.createRef();
  }

  handleClick(event) {
    this.setAnchorEl(event.currentTarget);
  }

  setAnchorEl(value) {
    this.setState({
      anchorEl: value,
      open: !this.state.open,
    });
  }

  handleClose() {
    this.setAnchorEl(null);
  }

  handleChange=(e)=>{
this.setState({
  [e.target.name]:e.target.value
})
  }

  componentDidMount() {
   
    fetch(`${base.base_url}/property_portal/property_portal/property/retrivePropertyForLandingage`, {
            headers: {
              "Content-Type": "application/json",
            },
            method: "GET",
          })
            .then((res) => {
              return res.json();
            })
            .then((result) => {
              console.log(result)

             this.setState({
   flats :  result.flats,
   commercial :  result.commercial,
   land :  result.land,
   independent_house: result.independent_house
             })


              })

  }


  toggleDrawer = (newOpen) => () => {
    this.setState({
      open: true
    })
  };

  toggleDrawerr = (newOpen) => () => {
    this.setState({
      open: false
    })
  };


   formatIndianCurrency=(num)=>{
  if (num >= 10000000) {
    return (num / 10000000).toFixed(2) + ' Cr';
  } else if (num >= 100000) {
    return (num / 100000).toFixed(2) + ' Lakh';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(2) + ' K';
  } else {
    return num.toString();
  }
}




saveLeads=()=>{
  
  if(
    this.state.name != "",
this.state.email!= "",
this.state.phone!= ""
  ){
    fetch(`${base.base_url}/property_portal/property_portal/property/addNewLeads`, {
      headers:{
        'authorization': `Bearer ${sessionStorage.getItem('token')}`,
    'content-type':'application/json',
   // 'Access-Control-Allow-Origin': 'http://localhost:3000',
      },
          method: "post",
          body:JSON.stringify({
                      email : this.state.email,
                      phone:this.state.phone,
                      name :this.state.name,
                      propertyDetails:this.state.propertyDetails
            })
  
        }).then(function(response) {
          return response.json();
        })
        .then(async(data)=> {
          this.setState({
            name:'',
            email:"",
            phone:"",
            is_enquiry_open:false
          })
         alert("Enquiry done")
        });
  }else{
    alert("fill all fields")
  }
}





  render() {

    return (
      <div>
        <AppHeader/>
        <Box>

          {
            ///// desktop view here and solution
          }

          <Box>
           <VoiceToText categoryList ={[]}/>
          </Box>



          <Box sx={{ display: { xs: "none", sm: "none", md: "block" },mt:-5 }}>

            <Box sx={{ minHeight: 750, background: "#ffffff" }}>
              <Container maxWidth="xl">
              
             <br/>
             <br/>
                
                <Box>
                  <Grid container spacing={1}>
                    <Grid item size={{ xs: 12, sm: 12, md: 12}}>

                      <Box>
                        <Typography
                          variant="h2"
                          sx={{
                            fontSize: 22,
                            fontWeight: "550",
                            color: "#0a1d3e",
                            mb:2
                          }}
                        >
                          We've got properties in Pune for everyone
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            overflowX: "scroll",
                            overflowY: "hidden",
                            mb: 1,
                            whiteSpace: "nowrap",
                            scrollbarWidth: "none",
                          }}
                        >
                          {[one,two,three,four,three].map((i) => (
                            <Box onClick={()=>this.props.navigate('/properties')}>
                                
                                <Box sx={{height:170,width:300,mr:2,borderRadius:2,backgroundImage: `url(${i})`, backgroundSize: 'cover',backgroundRepeat: 'no-repeat',backgroundPosition: 'center'}}>
                                   <Box sx={{height:170,width:300}}>

                                      <Typography sx={{fontSize:18,fontWeight:'700',color:'white',pt:10,pl:2}}>Project</Typography>
                                          
                                      <Button endIcon={<EastIcon/>} sx={{mt:0.2,pl:2,color:'#fff',fontSize:13,fontWeight:'bold'}} >Explore </Button>


                                   </Box>
                                </Box>

                            </Box>
                          ))}
                        </Box>
                      </Box>

                      <br />

                      <Box sx={{ backgroundColor: "#fbfefe" ,display:this.state.flats.length > 0?'block':'none'}}>
                        <Typography
                          variant="h2"
                          sx={{
                            fontSize: 20,
                            fontWeight: "550",
                            color: "#0a1d3e",
                            ml: 2,
                            pt: 2,
                          }}
                        >
                         Popular flats available
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            overflowX:'scroll',
                            scrollbarWidth: "none",
                            p: 2,
                          }}
                        >
                          {this.state.flats.map((row, i) => (
                            <Box  key={i._id}  sx={{ height: 350,width: 270,mr:1}}>
                            <Paper
                              elevation={0}
                              sx={{
                                height: 350,
                                width: 270,
                                backgroundColor:'#071435',
                                borderRadius: 2,
                                mr: 1,
                              }}
                            >
                              <Box sx={{height:180,width:'100%'}}>
                                 <img style={{height:180,width:270,objectFit:'cover',borderTop:4}} src={base.base_url+'/'+row.property_thumbnail_img}/>
                              </Box>
                                <Typography sx={{fontSize:13,mt:1,ml:1,fontWeight:'500',color:'#fff'}}>{row.no_of_bed_room}</Typography>
                                <Typography sx={{fontSize:19,mt:1,ml:1,fontWeight:'600',color:'#fff'}}>{this.formatIndianCurrency(row.property_price)} | {row.property_area} sqft</Typography>
                                <Typography sx={{fontSize:13,mt:1,ml:1,fontWeight:'500',color:'#fff'}}>{row.property_street_name},{row.property_city_name},{row.property_district},{row.property_state} - {row.property_area_pincode} </Typography>
                                <Box sx={{mt:1}}>
                                  <Button size="small" sx={{fontSize:11,ml:1,backgroundColor:'#ab266c'}} startIcon={<CallIcon sx={{height:11,width:11}}/>} variant="contained" onClick={()=>this.setState({
      is_enquiry_open:true,
      propertyDetails:row
     })}>Enquire Now</Button>
                                </Box>

                            </Paper>
                            </Box>
                          ))}
                        </Box>
                        <br />
                      </Box>

                     <br/>
<Box sx={{display:this.state.independent_house.length > 0?'block':'none'}}>
                   <Typography sx={{fontSize:22,fontWeight:'bold',ml:1}}>Independednt Villa & Home</Typography>
                   <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            maxWidth:'100%',
                            overflowX: "scroll",
                            mt:0.5,
                            mb: 2,
                            scrollbarWidth: "none",
                          }}
                        >
          {
            this.state.independent_house.map((row,e)=>(
              
        <Box  sx={{minHeight:250,m:1,width:260}}>
     <Paper elevation={1} sx={{minHeight:310,width:260 }}>
 

     <img src={base.base_url+'/'+row.property_thumbnail_img} style={{height:150,width:'100%',objectFit:'cover',borderTopLeftRadius:3,borderTopRightRadius:3}}/>


     <Typography sx={{fontSize:15,fontWeight:'600',color:'#0f1f42',textAlign:'left',mt:1,ml:1}}>
       Independent Home 
     </Typography>

     <Typography  sx={{mt:0.8,color:'grey',fontWeight:'500',fontSize:12,textAlign:'left',ml:1}}>
      {row.no_of_bed_room}
     </Typography>
                                     <Typography sx={{fontSize:17,mt:1,ml:1,fontWeight:'600',color:'#ff7c7c'}}>{this.formatIndianCurrency(row.property_price)} | {row.property_area} sqft</Typography>
                                <Typography sx={{fontSize:13,mt:1,ml:1,fontWeight:'500',color:'#f76464'}}>{row.property_street_name},{row.property_city_name},{row.property_district},{row.property_state} - {row.property_area_pincode} </Typography>
  
     <Link  sx={{fontSize:15,fontWeight:'600',color:'#0f1f42',textAlign:'left',mt:1,ml:1}}>
      Get Quato
     </Link>

     <Button variant="contained" disableElevation size="small" startIcon={<CallIcon/>} sx={{ml:1,mt:2,mb:1,fontSize:11}}  
     onClick={()=>this.setState({
      is_enquiry_open:true,
      propertyDetails:row
     })}>View Number</Button>
   </Paper>
         </Box>
            ))
          }
         
                  



                   </Box>
</Box>
                   <br/>

<Box sx={{display:this.state.land.length > 0?'block':'none'}}>
                        <Typography sx={{fontSize:22,fontWeight:'bold',ml:1}}>Land</Typography>
                         <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            maxWidth:'100%',
                            overflowX: "scroll",
                            mt:0.5,
                            mb: 2,
                            scrollbarWidth: "none",
                          }}
                        >
          {
           this.state.land.map((row,i)=>(

         <Box  sx={{minHeight:250,m:1,width:260}} >
     <Paper elevation={1} sx={{minHeight:310,width:260 }}>


       <img src={base.base_url+'/'+row.property_thumbnail_img} style={{height:150,width:'100%',objectFit:'cover',borderTopLeftRadius:3,borderTopRightRadius:3}}/>

 
 <Typography sx={{fontSize:17,mt:1,ml:1,fontWeight:'600',color:'#ff7c7c'}}>{this.formatIndianCurrency(row.property_price)} | {row.property_area} sqft</Typography>
                                <Typography sx={{fontSize:13,mt:1,ml:1,fontWeight:'500',color:'#f76464'}}>{row.property_street_name},{row.property_city_name},{row.property_district},{row.property_state} - {row.property_area_pincode} </Typography>
  
     <br/>
     <Button variant="contained" disableElevation size="small" startIcon={<CallIcon/>} sx={{ml:1,mt:1,mb:1,fontSize:11,backgroundColor:'#ab266c'}} onClick={()=>this.setState({
      is_enquiry_open:true,
      propertyDetails:row
     })}>View Number</Button>
   </Paper>
         </Box>
            ))
          }
         
                  



                   </Box>
</Box>

                   <br/>

<Box sx={{display:this.state.commercial.length > 0?'block':'none'}}>
                        <Typography sx={{fontSize:22,fontWeight:'bold',ml:1}}>Commercial</Typography>
                         <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            maxWidth:'100%',
                            overflowX: "scroll",
                            mt:0.5,
                            mb: 2,
                            scrollbarWidth: "none",
                          }}
                        >
          {
            this.state.commercial.map((row,i)=>(

         <Box onClick={()=>this.props.navigate(`/properties/:${row._id}`)} sx={{minHeight:250,m:1,width:260}} >
     <Paper elevation={1} sx={{minHeight:310,width:260 }}>


       <img src={base.base_url+'/'+row.property_thumbnail_img} style={{height:150,width:'100%',objectFit:'cover',borderTopLeftRadius:3,borderTopRightRadius:3}}/>

 
 <Typography sx={{fontSize:17,mt:1,ml:1,fontWeight:'600',color:'#ff7c7c'}}>{this.formatIndianCurrency(row.property_price)} | {row.property_area} sqft </Typography>
                                <Typography sx={{fontSize:13,mt:1,ml:1,fontWeight:'500',color:'#f76464'}}>{row.property_street_name},{row.property_city_name},{row.property_district},{row.property_state} - {row.property_area_pincode} </Typography>
  
     <br/>
     <Button variant="contained" disableElevation size="small" startIcon={<CallIcon/>} sx={{ml:1,mt:1,mb:1,fontSize:11,backgroundColor:'#ab266c'}} onClick={()=>this.setState({
      is_enquiry_open:true,
      propertyDetails:row
     })}>View Number</Button>
   </Paper>
         </Box>
            ))
          }
         
                  



                   </Box>
</Box>









                  
                      <br />
                    </Grid>
                  </Grid>
                </Box>
              </Container>
            </Box>
          </Box>



          {
            ///// mobile view and list display here and founded ??
          }

         <br/>

          <Box sx={{ display: { xs: "block", sm: "block",md:'none' }}}>
            <Container maxWidth="xl">
   
            


              <Box sx={{ minHeight: 200, mt: 2 }}>
                <Typography sx={{ fontSize: 19, fontWeight: "600" ,fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`,mb:1}}>
                Available Flats
                </Typography>

                <Grid container spacing={1}>


{
  this.state.flats.map((row,i)=>(
           <Grid item size={{ xs: 6 }}>
                    <Paper  elevation={0} sx={{ width: "100%", height: 220 }}>
                      <Box
                        sx={{
                          height: 150,
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          backgroundImage: `url(${base.base_url+"/"+row.property_thumbnail_img})`,
                          backgroundPosition: "center",
                          backgroundSize: "cover",
                          backgroundRepeat: "no-repeat",
                          borderRadius: 1,
                        }}
                      >
                  
                      </Box>
                      <Box>
                        <Typography
                          sx={{ fontSize: 12, color: "black", mt: 0.5,textTransform:'uppercase' ,lineClamp:2 }}
                        >
                         {row.property_name}
                        </Typography>
                        <Typography sx={{ fontSize: 11, color: "gray",m:0.5,lineClamp:2}}>
                          {row.property_street_name}, {row.property_city_name} - {row.property_area_pincode}
                        </Typography>
                      </Box>
                    </Paper>
           </Grid>
  ))
}
                 



                </Grid>
              </Box>

              <br />
              

              <Box sx={{ maxWidth: "100%" }}>
                <Typography
                  variant="h2"
                  sx={{ fontSize: 18, fontWeight: "550",fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`,mb:1}}>
                 Category & Link
                </Typography>
            

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    mt: 2,
                    mb: 2,
                    overflowX: "auto",
                    minHeight: 200,
                    whiteSpace: "nowrap",
                    scrollbarWidth: "none",
                  }}
                >
                {[one,two,three,four,five,six].map((i) => (
                            <Box onClick={()=>this.props.navigate(`/properties`)}>
                                
                                <Box sx={{height:170,width:300,mr:2,borderRadius:2,backgroundImage: `url(${i})`, backgroundSize: 'cover',backgroundRepeat: 'no-repeat',backgroundPosition: 'center'}}>
                                   <Box sx={{height:170,width:300}}>

                                      <Typography sx={{fontSize:18,fontWeight:'700',color:'white',pt:10,pl:2}}>Project</Typography>
                                          
                                      <Button endIcon={<EastIcon/>} sx={{mt:0.2,pl:2,color:'#fff',fontSize:13,fontWeight:'bold'}}>Explore </Button>


                                   </Box>
                                </Box>

                            </Box>
                          ))}
                </Box>
              </Box>


              <br />


              <Box sx={{ maxWidth: "100%" }}>
                <Typography
                  variant="h2"
                  sx={{ fontSize: 18, fontWeight: "550",fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`,mb:1}}>
                 Independent House
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    mt: 2,
                    mb: 2,
                    overflowX: "auto",
                    scrollbarWidth: "none",
                  }}
                >
                      {this.state.independent_house.map((row, i) => (
                            <Box key={i._id} onClick={()=>this.props.navigate('/properties')}  sx={{ height: 350,width: 270,mr:1}}>
                            <Paper
                              elevation={0}
                              sx={{
                                height: 350,
                                width: 270,
                                backgroundColor:'#071435',
                                borderRadius: 2,
                                mr: 1,
                              }}
                            >
                              <Box sx={{height:180,width:'100%'}}>
                                 <img style={{height:180,width:270,objectFit:'cover',borderTop:4}} src={base.base_url+"/"+row.property_thumbnail_img}/>
                              </Box>
                                <Typography sx={{fontSize:13,mt:1,ml:1,fontWeight:'500',color:'#fff'}}>{row.no_of_bed_room}</Typography>
                                <Typography sx={{fontSize:19,mt:1,ml:1,fontWeight:'600',color:'#fff'}}> {this.formatIndianCurrency(row.property_price)} | {row.property_area} sqft </Typography>
                                <Typography sx={{fontSize:13,mt:1,ml:1,fontWeight:'500',color:'#fff'}}> {row.property_street_name},{row.property_city_name},{row.property_district},{row.property_state} - {row.property_area_pincode} </Typography>
                                <Box sx={{mt:1}}>
                                  <Button size="small" sx={{fontSize:11,ml:1,backgroundColor:'#ab266c'}} startIcon={<CallIcon sx={{height:11,width:11}}/>} variant="contained" onClick={()=>this.setState({
      is_enquiry_open:true,
      propertyDetails:row
     })}>Contact</Button>
                                </Box>

                            </Paper>
                            </Box>
                          ))}
                </Box>
              </Box>


              <br />


              <Box sx={{ maxWidth: "100%" }}>
                <Typography
                  variant="h2"
                  sx={{ fontSize: 18, fontWeight: "550",fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`,mb:1}}>
                   Land Available
                </Typography>
            
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    mt: 2,
                    mb: 2,
                    overflowX: "auto",
                    scrollbarWidth: "none",
                  }}
                >
                    {
            this.state.land.map((row,e)=>(
              
        <Box  sx={{minHeight:250,m:1,width:260}}>
     <Paper elevation={1} sx={{minHeight:310,width:260 }}>
 

     <img src={base.base_url+"/"+row.property_thumbnail_img} style={{height:150,width:'100%',objectFit:'cover',borderTopLeftRadius:3,borderTopRightRadius:3}}/>


     <Typography sx={{fontSize:15,fontWeight:'600',color:'#0f1f42',textAlign:'left',mt:1,ml:1}}>
      Land available
     </Typography>

     <Typography  sx={{mt:0.8,color:'grey',fontWeight:'500',fontSize:12,textAlign:'left',ml:1}}>
    {row.property_area} sqft
     </Typography>
  
     <Link  sx={{fontSize:15,fontWeight:'600',color:'#0f1f42',textAlign:'left',mt:2,ml:1}}>
      Get Quato
     </Link>

     <Button onClick={()=>this.setState({
      is_enquiry_open:true,
      propertyDetails:row
     })}  variant="contained" disableElevation size="small" startIcon={<CallIcon/>} sx={{ml:1,mt:2,mb:1,fontSize:11}} >View Number</Button>
   </Paper>
         </Box>
            ))
          }
                </Box>
              </Box>




              <Box sx={{ maxWidth: "100%" }}>
                <Typography
                  variant="h2"
                  sx={{ fontSize: 18, fontWeight: "550",fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`,mb:1}}>
               Commercial 
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    mt: 2,
                    mb: 2,
                    overflowX: "auto",
                    scrollbarWidth: "none",
                  }}
                >
                    {
            this.state.commercial.map((row,i)=>(

         <Box onClick={()=>this.props.navigate('/properties')} sx={{minHeight:250,m:1,width:260}} >
     <Paper elevation={1} sx={{minHeight:310,width:260 }}>


       <img src={base.base_url+"/"+row.property_thumbnail_img} style={{height:150,width:'100%',objectFit:'cover',borderTopLeftRadius:3,borderTopRightRadius:3}}/>

 
     <Typography  sx={{fontSize:15,fontWeight:'600',color:'#0f1f42',textAlign:'left',mt:1,ml:1}}>
         {row.property_area} sqft
     </Typography>
     <Typography  sx={{mt:0.8,color:'grey',fontWeight:'500',fontSize:12,textAlign:'left',ml:1}}>
      {row.property_street_name},{row.property_city_name},{row.property_district},{row.property_state} - {row.property_area_pincode} 
     </Typography>
     <br/>
     <Button variant="contained" disableElevation size="small" startIcon={<CallIcon/>} sx={{ml:1,mt:1,mb:1,fontSize:11,backgroundColor:'#ab266c'}} 
     onClick={()=>this.setState({
      is_enquiry_open:true,
      propertyDetails:row
     })}
     
     >View Number</Button>
   </Paper>
         </Box>
            ))
          }
                </Box>
              </Box>
              

            </Container>
          </Box>
 <Footer/>
        </Box>





  <Box>
          <Modal
            open={this.state.is_enquiry_open}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "27%", lg: "27%" },
                  height: "65vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Paper
                    onClick={() =>
                      this.setState({
                        is_enquiry_open: false,
                        name : "",
name : "",
phone : "",
email : ""
                      })
                    }
                    elevation={5}
                    sx={{
                      height: 30,
                      width: 30,
                      borderRadius: 1,
                      backgroundColor: "#fff",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mr: -1,
                      mt: -1,
                    }}
                  >
                    <CloseIcon
                      sx={{ height: 20, width: 20, color: "#2486bb" }}
                    />
                  </Paper>
                </Box>

                <Typography
                  sx={{
                    fontSize: 17,
                    fontWeight: "600",
                    color:'#008ffb',

                    paddingLeft: { xs: 2, sm: 4 },
                    mb: 2,
                  }}
                >
                Enquire Now :
                </Typography>
                <Divider />
                <Box
                  sx={{
                    overflowY: "scroll",
                    "&::-webkit-scrollbar": {
                      width: "5px",
                      borderRadius: 10,
                    },
                  }}
                >
                  <Box
                    sx={{
                      paddingLeft: { xs: 2, sm: 4 },
                      paddingRight: { xs: 2, sm: 4 },
                      height: "76vh",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 11,
                        fontWeight: "600",
                        padding: 0.2,
                        mt: 1,
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      {" "}
                      YOUR NAME
                      <Typography sx={{ color: "red" }}>*</Typography>
                    </Typography>
                    <TextField
                      type="text"
                      InputProps={{
                        sx: { fontSize: 11, fontWeight: "600" },
                      }}
                      name="name"
                      value={this.state.name}
                      onChange={this.handleChange}
                      fullWidth
                      sx={{ backgroundColor: "#fff" }}
                      size="small"
                    />

                    <Typography
                      sx={{
                        fontSize: 11,
                        fontWeight: "600",
                        padding: 0.2,
                        mt: 1,

                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      EMAIL ID
                      <Typography sx={{ color: "red" }}>*</Typography>
                    </Typography>
                    <TextField
                      type="text"
                      InputProps={{
                        sx: { fontSize: 11, fontWeight: "600" },
                      }}
                      name="email"
                      value={this.state.email}
                      onChange={this.handleChange}
                      sx={{ backgroundColor: "#fff" }}
                      fullWidth
                      size="small"
                    />

                    <Typography
                      sx={{
                        fontSize: 11,
                        fontWeight: "600",
                        padding: 0.2,
                        mt: 1,
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      PHONE <Typography sx={{ color: "red" }}>*</Typography>
                    </Typography>
                    <TextField
                      sx={{ backgroundColor: "#fff" }}
                      type="text"
                      InputProps={{
                        sx: { fontSize: 11, fontWeight: "600" },
                      }}
                      name="phone"
                      onChange={this.handleChange}
                      value={this.state.phone}
                      fullWidth
                      size="small"
                    />
                    
  

                    <Button
                      onClick={this.saveLeads}
                      variant="contained"
                      disableElevation
                      size="small"
                      sx={{
                        backgroundColor: "#2486bb",
                        mt: 2,
                        fontSize:11,
                        textTransform: "none",
                      }}
                    >
                    Enquire Now
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Modal>
        </Box>



       
      </div>
    );
  }
}

export default Main;




export function Mainc(props){
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams()
  return (<Main param={param} location={location} navigate={navigate}></Main>)}
